<template>
	<div class="d21-select" :class="{'active': isListVisible}" v-click-outside="closeList">
		<!-- <i v-if="hasItems" class="icon-arrow-down d21-select-toggler"></i> -->
		<div v-if="hasItems" class="d21-select-toggler">
			<i class="material-icons">
			keyboard_arrow_down
			</i>
		</div>
		<img class="selectedLangImg" v-if="isLanguageSelect() && selectedItem" v-bind:src='"../../../public/flags/" + selectedItem + ".png"' />
		<input type="text" :value="getLabel(selectedItem)" @change="disable" @click="toggleList" readonly />
		<ul :style="itemListStyle" ref="itemList">
			<li v-for="item in list" :key="getValue(item)" :class="getValue(item) == inputVal ? 'active' : ''" @click="onItemClicked(item)">
				<img v-if="isLanguageSelect() && item" v-bind:src='"../../../public/flags/" + (item ? item : hub.culture) + ".png"' />
				{{ getLabel(item) }} 
			</li>
		</ul>
	</div>
</template>

<script>
	import hub from "../../scripts/_hub";
	export default {
		name: "d21-select",
		props: ["value", "list", "selector", "label"],
		data() {
			return {
				inputVal: this.value,
				isListVisible: false,
				selectedItem: null,
				isLanguageSelect: () => {
					let languageSelect = false;
					this.list.forEach(item => {
						if(item == hub.culture) {
							languageSelect = true;
						}
					});
					return languageSelect;
				},
				itemListStyle: {
					transform: ""
				}
			};
		},
		computed: {
			hasItems() {
				return this.list != null && this.list.length > 0;
			}
		},
		methods: {
			getLabel(item) {
				if (item == null) return;
				return this.label ? item[this.label] : item;
			},
			getValue(item) {
				return this.selector ? item[this.selector] : item;
			},
			onItemClicked(item) {
				this.inputVal = this.getValue(item);
				this.selectedItem = item;
				this.isListVisible = false;

				if(this.isLanguageSelect() && hub.culture != this.selectedItem){
					hub.culture = this.selectedItem;
					if (localStorage.culture != hub.culture){
						localStorage.culture = hub.culture;
					}
					location.reload();				
				}
				this.$emit("input", this.inputVal);
			},
			disable: function (e) {
				e.preventDefault();
			},
			toggleList() {
				this.isListVisible = !this.isListVisible;

				this.$nextTick(() => {
					if (this.isListVisible) {
						this.itemListStyle.transform = "";
						let xOffset = 0;
						const targetRect = this.$el.getBoundingClientRect(),
							itemList = this.$refs.itemList.getBoundingClientRect();

						if (targetRect.top + targetRect.height + itemList.height > window.screen.height) {
							xOffset = -targetRect.height - itemList.height;
							this.itemListStyle.transform = `translate(0px, ${xOffset}px)`;
						}
					}
				});
			},
			closeList() {
				this.isListVisible = false;
			}
		},
		mounted() {
			if(this.hasItems && this.isLanguageSelect()){
				this.list.forEach(item => {
					if(item == hub.culture) {
						this.selectedItem = item;
					}
				});
			}
			else if (this.hasItems) {
				let selectedItem = this.list.filter(x => {
					return this.getValue(x) === this.value;
				});

				this.selectedItem = selectedItem && selectedItem.length ? selectedItem[0] : this.list[0];
			}
		},
		watch: {
			"value": {
				handler(newValue) {
					this.selectedItem = this.list.find((item) => item[this.selector] == newValue);
				}
			}
		},
	};
</script>

<style lang="less" src="../../styles/ui/select.less"></style>